/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 */

const isLocationDifferent = (
  location,
  anotherLocation,
  { ignoreHashChange, ignoreSearchChange } = {}
) => {
  const locationChanged = location !== anotherLocation
  if (!location || !anotherLocation || !locationChanged) {
    return locationChanged
  }
  const hashChanged = location.hash !== anotherLocation.hash
  const searchChanged = location.search !== anotherLocation.search
  const pathnameChanged = location.pathname !== anotherLocation.pathname

  let locationChangedMeaningfully = false
  if (ignoreHashChange && ignoreSearchChange) {
    locationChangedMeaningfully = pathnameChanged
  } else if (ignoreSearchChange) {
    locationChangedMeaningfully = pathnameChanged || hashChanged
  } else if (ignoreHashChange) {
    locationChangedMeaningfully = pathnameChanged || searchChanged
  } else {
    locationChangedMeaningfully = pathnameChanged || searchChanged || hashChanged
  }
  return locationChangedMeaningfully
}

export default isLocationDifferent
